import { render, staticRenderFns } from "./futuresInfo.vue?vue&type=template&id=9ded5500&scoped=true"
import script from "./futuresInfo.vue?vue&type=script&lang=js"
export * from "./futuresInfo.vue?vue&type=script&lang=js"
import style0 from "./futuresInfo.vue?vue&type=style&index=0&id=9ded5500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ded5500",
  null
  
)

export default component.exports